module.exports = __webpack_public_path__ + "img/21_88.71630f7e.png";